import React from "react";
import BaseImage from "@gc-npm/components.c-image";

const Image = ({ version, ...props }) => {
  const bundleId = process.env.NEXT_PUBLIC_BUNDLE_ID;

  if (bundleId === undefined || bundleId === null || bundleId === "") {
    return <BaseImage {...props} version={version} />;
  }

  const baseVersion = version === undefined || version === null ? "" : String(version);
  const computedVersion = `${baseVersion}${bundleId}`;

  return <BaseImage {...props} version={computedVersion} />;
};

export default Image;
